import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// ✅ 1. Import your logos
import sunoraLogo from "../assets/logo_sunora.jpg"; // Adjust path if needed
import geoLogo from "../assets/logo_geo.png";       // Adjust path if needed

import "./LoginPage.css";
const API_URL = process.env.REACT_APP_API_URL;
function LoginPage() {
  const [company, setCompany] = useState("SUNORA"); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
        company,
      });
      const { access_token } = response.data;
      localStorage.setItem("token", access_token);
      localStorage.setItem("company", company);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid credentials or access denied");
    }finally {
      setIsLoading(false); // ✅ Re-enable button on success or error
    }
  };

  // ✅ 2. Determine which logo to display based on the selected company
  const currentLogo = company === "SUNORA" ? sunoraLogo : geoLogo;

  return (
    // ✅ 3. Main wrapper with a dynamic theme class
    <div className={`login-page-wrapper theme-${company.toLowerCase()}`}>
      <div className="login-container">
        
        {/* ✅ 4. Display the dynamic logo */}
        <img src={currentLogo} alt={`${company} Logo`} className="logo-image" />

        <h2>Login</h2>

        <div className="slider-container">
          <label className={`slider-label ${company === 'SUNORA' ? 'active' : ''}`}>
            <input
              type="radio" name="company" value="SUNORA"
              checked={company === "SUNORA"}
              onChange={() => setCompany("SUNORA")}
            />
            Sunora
          </label>
          <label className={`slider-label ${company === 'GEOCHEMICAL' ? 'active' : ''}`}>
            <input
              type="radio" name="company" value="GEOCHEMICAL"
              checked={company === "GEOCHEMICAL"}
              onChange={() => setCompany("GEOCHEMICAL")}
            />
            Geo Chemical
          </label>
        </div>

        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              id="email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              id="password" type="password" placeholder="Password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={isLoading}>{isLoading ? "Logging in..." : "Login"}</button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;